document.addEventListener('DOMContentLoaded', function() {
    const openCookiesModal = document.querySelector('#wp-admin-bar-h5-tac-display a')

    if (openCookiesModal) {
        openCookiesModal.addEventListener('click', (e) => {
            e.preventDefault()
            const tarteaucitronRoot = document.getElementById('tarteaucitronRoot')
            const tarteaucitronAlertBig = document.getElementById('tarteaucitronAlertBig')
    
            // console.log(tarteaucitronRoot);
    
    
            tarteaucitronRoot.classList.add('tarteaucitronBeforeVisible')
            tarteaucitronAlertBig.style = 'display: block; opacity: 1;'
        })
    }
});